(function () {
  var KEY = 'da_audience';
  if (window.location.pathname === '/') return;
  var aud;
  try { aud = localStorage.getItem(KEY); } catch (e) { return; }
  if (!aud) return;
  function inject() {
    if (document.querySelector('.dai-switch-link')) return;
    var a = document.createElement('a');
    a.href = '/';
    a.className = 'dai-switch-link';
    a.textContent = '⇄ Switch';
    a.addEventListener('click', function () {
      try { localStorage.removeItem(KEY); } catch (e) {}
    });
    var target = document.querySelector('.header__column--right') ||
                 document.querySelector('header-actions') ||
                 document.querySelector('#header-component');
    if (target) target.insertBefore(a, target.firstChild);
  }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', inject)
    : inject();
})();
